import { Component, EventEmitter, Input, Output } from '@angular/core';

type ButtonType = 'primary' | 'secondary' | 'contrast' | 'outline' | 'gray';

@Component({
    selector: 'ui-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent {
  @Output('p-click') click = new EventEmitter<MouseEvent>();
  @Input('p-loading') loading: boolean = false;
  @Input('p-type') type: ButtonType = 'primary';
  @Input('p-disabled') disabled: boolean = false;
  @Input('p-padding') padding: boolean = false;

  handleClick(event: MouseEvent) {
    if(!this.loading)
      this.click.emit(event);
  }
}